import type { FC } from 'react'
import cn from 'classnames'
import type { CheckboxProps } from '.'
import s from './checkbox.module.css'

const Checkbox: FC<CheckboxProps> = ({ className, name, value, label, checked, handleChange }) => {
  return (
    <label htmlFor={name} className={cn(s.root, className)}>
      <input
        type="checkbox"
        id={name}
        name={name}
        value={value}
        className={s.input}
        checked={checked}
        onChange={() => handleChange(value, !checked)}
      />
      <span>{label}</span>
    </label>
  )
}

export default Checkbox
